module.exports = __webpack_public_path__ + "static/img/10.11695e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/10.png
// module id = DXtS
// module chunks = 0